// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"47dc4938","453":"4531ba92","796":"590f16ea"}[chunkId] + ".chunk.js";
};